/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM, createNamespace } from 'src/util/bem';
import './singleStationReport.less';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import DayReport from './dayReport/dayReport';
import StationSider from 'src/pages/stationDetail/component/stationSider';
let bem = createBEM('single-station-report');

export interface SingleStationReportPropsI {
    value: string | number;
}

@Component
export default class SingleStationReport extends Vue.Component<SingleStationReportPropsI> {
    
    mn: string = '';
    singleChange(data: StationListDOI.RowDataI) {}
    type: string = '';
    async typeChnage(type: string) {
        this.type = type;
    }

    siderCloseOrOpen: boolean = true;

    // async mounted() {
    //     let station = await (this.$refs.stationTree as StationTree).getStations();
    //     this.mn = station[0].mn
        
    // }
    zoomFlag(h) {
        this.siderCloseOrOpen = h;
    }

    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')} v-show={this.siderCloseOrOpen}>
                    {/* <FrameSideBg style="height: 100%">
                        <div class={[createNamespace(['pa10']), bem('tree-wrapper')]}>
                            <StationTree
                                class={createNamespace(['mt10', 'mb10'])}
                                ref="stationTree"
                                v-model={this.mn}
                                on-click={this.singleChange.bind(this)}
                            />
                        </div>
                    </FrameSideBg> */}
                    <StationSider
                        class={createNamespace(['mt10', 'mb10'])}
                        ref="stationTree"
                        v-model={this.mn}
                        defaultSelect={true}
                        on-click={this.singleChange.bind(this)}
                    />
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <DayReport mn={this.mn} on-zoomFlag={this.zoomFlag} showZoom={true}></DayReport>
                    {/* <MonthReport v-if={this.currentReport==='月报'} on-change={v=> this.currentReport = v}></MonthReport> */}
                </i-content>
            </layout>
        );
    }
}
